"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
var _slicedToArray2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/slicedToArray.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _index = require("@/utils/index");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _xlsx = _interopRequireDefault(require("xlsx"));
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _echarts = _interopRequireDefault(require("echarts"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Order',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default,
    selPlat: _selPlat.default
  },
  props: {
    user_type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    xlsxName: function xlsxName() {
      var xlsxName = '订单记录';
      var b = '';
      var e = '';
      if (this.form.begin) {
        b = this.parseTime(this.form.begin / 1000, '{y}.{m}{d}');
      }
      if (this.form.end) {
        e = this.parseTime(this.form.end / 1000, '{y}.{m}{d}');
      }
      if (b && e) {
        xlsxName = b + '-' + e;
      } else if (b || e) {
        xlsxName = b || e;
      }
      return xlsxName;
    },
    device: function device() {
      return this.$store.state.app.device;
    },
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    },
    showNfcNoFilter: function showNfcNoFilter() {
      var deviceType = String(this.listQuery.device_type);
      return deviceType === '-1' || deviceType === '3' || this.deviceKeyObj[deviceType] === '充电桩';
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    agentDevice: function agentDevice() {
      return this.$store.state.user.agentDevice;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    },
    siteInfo: function siteInfo() {
      return this.$store.getters.siteInfo;
    }
  },
  data: function data() {
    var _this = this;
    return {
      showExtraTabs: false,
      clickSubmit: false,
      dealPhone: _index.dealPhone,
      drawer: true,
      cat_id: [],
      search_regions_tag: [],
      categoryList: [],
      areaList: [],
      form: {
        cat_id: '',
        search_regions_tag: '',
        order_sn: this.$route.query.order_sn || '',
        search_uid: this.$route.query.search_uid || '',
        goods_sn: this.$route.query.goods_sn || '',
        store_name: this.$route.query.store_name || '',
        store_id: this.$route.query.store_id || '',
        transaction_id: this.$route.query.transaction_id || '',
        nfc_no: this.$route.query.nfc_no || ''
      },
      numInfo: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        device_type: '-1',
        search_user_type: 0,
        son_id: this.$route.query.son_id || '',
        order_type: this.$route.query.order_type || '4',
        mini_type: this.$route.query.mini_type || '0',
        search_goods_id: this.$route.query.search_goods_id || '',
        pay_type: '0',
        new_pay_type: '0',
        type: 1,
        start: 1,
        limit: 10
      },
      orderStatus: {
        '-1': '待支付',
        0: '未启动',
        1: '进行中',
        2: '已完成',
        3: '手动完结',
        4: '异常',
        5: '超时完成'
      },
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400;
          }
        }
      },
      orderNum: {},
      order: {},
      selID: [],
      // 结束订单
      endOrderDialog: false,
      endOrderObj: {
        return_time: '',
        check_bao_backed: true
      },
      // 订单详情
      detailDialog: false,
      // 订单退款
      refundDialog: false,
      refundObj: {
        refund_2_balance: 1,
        refund_money: ''
      },
      sort_id_key: this.$route.query.sort_id_key || false,
      //宝信息
      baoDialog: false,
      baoList: [],
      baoStatus: ['未弹出', '准备弹出', '已弹出', '有异物', '充电口有异常'],
      // 退款详情
      washRefundDialog: false,
      washRefund: {},
      refundStatus: {
        1: '申请中',
        2: '已拒绝',
        3: '已通过',
        4: '已退款'
      },
      outStatus: false,
      excel: false,
      percentage: 0,
      wbout: {},
      pt_steal_fc: 0,
      wi: 0,
      // 设备类型排序
      deviceSortArr: [],
      deviceSortDialog: false,
      // 订单交易统计
      currentPeriod: 'days',
      // 默认当前月份
      customPeriodRange: [],
      // 自定义时间范围 [开始时间, 结束时间]
      currentPeriodText: '今天',
      // 当前显示的时间范围文本
      periodOptions: [{
        label: '今天',
        value: 'days'
      }, {
        label: '昨天',
        value: 'yesterday'
      }, {
        label: '本周',
        value: 'week'
      }, {
        label: '上周',
        value: 'lastWeek'
      }, {
        label: '本月',
        value: 'month'
      }, {
        label: '上月',
        value: 'lastMonth'
      }, {
        label: '季度(近3月)',
        value: 'quarter'
      }, {
        label: '年度（当年）',
        value: 'year'
      }, {
        label: '合计',
        value: 'total'
      }],
      deviceChartData: [],
      // 设备类型数据
      summary: {
        orderAmount: 0,
        fee: 0,
        total: 0,
        feeTariff: '' // 添加费率字段
      },
      // 订单交易总览柱状图表
      orderStatsDialogVisible: false,
      // 控制订单交易统计弹窗显示
      chartLoading: false // 图表加载状态
    };
  },
  mounted: function mounted(options) {
    // 获取页面传参
    if (this.$route.query.callPages == "panelGroup") {
      // 首页跳转
      this.showOrderStatsDialog();
    }
    this.listQuery.search_user_type = this.user_type;
    this.getList();
    this.getCategory();
    this.getArea();
  },
  methods: {
    /**
     * 订单数量
     */
    getOrderNum: function getOrderNum() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.listQuery, this.form);
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      this.$get('agentapi/order_data_stat_num_pc', listQuery).then(function (res) {
        _this2.numInfo = res;
      });
    },
    /**
     * 展开/收起更多订单类型
     */
    toggleExtraTabs: function toggleExtraTabs() {
      this.showExtraTabs = !this.showExtraTabs;
      if (this.showExtraTabs) {
        this.getOrderNum();
      }
    },
    /**
     * 校验是否可选
     */
    checkSel: function checkSel(row) {
      return row.delivery_status == 1;
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.order_type = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {
          cat_id: '',
          search_regions_tag: '',
          order_sn: '',
          search_uid: '',
          goods_sn: '',
          store_name: '',
          store_id: '',
          transaction_id: '',
          nfc_no: '',
          custom_nick_name: '',
          custom_mobile: '',
          out_order_no: '',
          begin: '',
          end: ''
        };
        this.cat_id = [];
        this.search_regions_tag = [];
        this.listQuery.start = 1;
        this.listQuery.limit = 10;
      } else {
        if (this.cat_id && this.cat_id.length > 0) {
          this.form.cat_id = this.cat_id[this.cat_id.length - 1];
        }
        if (this.search_regions_tag && this.search_regions_tag.length > 0) {
          this.form.search_regions_tag = this.search_regions_tag[this.search_regions_tag.length - 1];
        }
        this.listQuery.start = 1;
        this.listQuery.total = 10;
      }
      if (this.outStatus) this.outStatus = false;
      if (this.showExtraTabs) {
        this.getOrderNum();
      }
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this3 = this;
      var params = Object.assign({}, this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      if (params.end && params.begin) {
        if (params.end - params.begin > 90 * 24 * 60 * 60 * 1000) {
          this.$message.error('筛选时间维度不可超过90天');
          return;
        }
        params.page_switch = 1;
      } else if (params.order_type == 0) {
        params.begin = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
        params.end = params.begin + 86400;
        params.order_type = 4;
      }
      if (params.begin) params.begin = this.parseTime(params.begin, '{y}-{m}-{d}');
      if (params.end) params.end = this.parseTime(params.end, '{y}-{m}-{d}');
      if (params.device_type == -1 || params.device_type == '-1') delete params.device_type;
      var nfcNo = String(this.form && this.form.nfc_no || '').trim();
      if (this.showNfcNoFilter && nfcNo) {
        params.nfc_no = nfcNo;
      } else {
        delete params.nfc_no;
      }
      if (this.sort_id_key && window.sort_id_key) params.sort_id_key = window.sort_id_key;
      this.$get('agentapi/search/query_orders_new', params).then(function (res) {
        if (_this3.outStatus) {
          _this3.list = res.list;
          _this3.pt_steal_fc = res.pt_steal_fc;
          if (params.limit > res.list.length) {
            _this3.listLoading = false;
            _this3.percentage = 100;
          } else {
            _this3.listQuery.start++;
            _this3.percentage = _this3.percentage < 95 ? _this3.percentage + 5 : 95;
          }
          _this3.$nextTick(function () {
            _this3.outTabdd('order_table', _this3.xlsxName);
          });
        } else {
          _this3.listLoading = false;
          _this3.list = res.list;
          _this3.pt_steal_fc = res.pt_steal_fc;
        }
        //if(res.list.length == params.limit) this.listQuery.total = (parseInt(params.start) + 2) * parseInt(params.limit)
        _this3.tableMaxH = window.innerHeight - _this3.$refs.order_table.$el.offsetTop - 80;
        _this3.postSetRecode(params.order_type);
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    /**
     * 获取商户类别
     */
    getCategory: function getCategory() {
      var _this4 = this;
      this.$get('agentapi/store/store_cat_list').then(function (res) {
        for (var i in res) {
          var obj = {
            value: res[i].cat_id,
            label: res[i].cat_name,
            children: []
          };
          if (_this4.cat_id == obj.value) {
            if (res[i].son_cat_list.length > 0) {
              _this4.form.cat_id = [obj.value, res[i].son_cat_list[0].cat_id];
            } else {
              _this4.form.cat_id = [obj.value];
            }
          }
          if (res[i].son_cat_list.length > 0) {
            for (var s in res[i].son_cat_list) {
              var child = res[i].son_cat_list[s];
              if (_this4.cat_id == child.cat_id) _this4.form.cat_id = [obj.value, child.cat_id];
              obj.children.push({
                value: child.cat_id,
                label: child.cat_name
              });
            }
          } else {
            obj.children = undefined;
          }
          _this4.categoryList.push(obj);
        }
      });
    },
    /**
     * 获取区域
     */
    getArea: function getArea() {
      var _this5 = this;
      this.$get('commonapi/tool/get_address_list').then(function (res) {
        for (var i in res) {
          var firstLevel = res[i];
          var obj = {
            value: firstLevel.tag,
            label: firstLevel.title,
            children: []
          };
          if (firstLevel.son_list.length > 0) {
            var secondLevel = firstLevel.son_list;
            for (var s in secondLevel) {
              var secondItem = secondLevel[s];
              obj.children.push({
                value: secondItem.tag,
                label: secondItem.title,
                children: []
              });
              if (secondItem.son_list.length > 0) {
                var thirdLevel = secondItem.son_list;
                for (var t in thirdLevel) {
                  var thirdItem = thirdLevel[t];
                  obj.children[s].children.push({
                    value: thirdItem.tag,
                    label: thirdItem.title
                  });
                }
              } else {
                obj.children = undefined;
              }
            }
          } else {
            obj.children = undefined;
          }
          _this5.areaList.push(obj);
        }
      });
    },
    /**
     * 手动结束订单
     */
    endOrder: function endOrder(type, row) {
      var _this6 = this;
      if (type == 1) {
        this.order = row;
        this.endOrderObj.return_time = Date.parse(new Date());
        this.endOrderDialog = true;
      } else {
        this.$alert('确定结束此订单吗？', '结束订单', {
          confirmButtonText: '确定',
          callback: function callback(action) {
            if (action == 'confirm') {
              _this6.clickSubmit = true;
              _this6.$get('agentapi/business/manual_finish_order', {
                order_id: row.order_id,
                bao_sn: row.goods_sn,
                return_time: _this6.endOrderObj.return_time / 1000,
                check_bao_backed: _this6.endOrderObj.check_bao_backed ? 1 : 0
              }).then(function (res) {
                // 【操作埋点】2026-05-25 pc_order_finish_1 手动结束订单（$get 成功后手动上报）
                _this6.$orderReport.reportOrderFinish(row.order_sn || row.order_id, "\u5F52\u8FD8\u65F6\u95F4\uFF1A".concat(_this6.parseTime(_this6.endOrderObj.return_time / 1000, '{y}-{m}-{d} {h}:{i}'), "\uFF0C\u68C0\u67E5\u5F52\u8FD8\uFF1A").concat(_this6.endOrderObj.check_bao_backed ? '是' : '否'));
                _this6.endOrderDialog = false;
                _this6.order = {};
                _this6.clickSubmit = false;
                _this6.$message({
                  message: '结束成功',
                  type: 'success'
                });
                row.order_status = 3;
                //刷新列表
                _this6.getList();
              }).catch(function (err) {
                _this6.clickSubmit = false;
              });
            }
          }
        });
      }
    },
    /**
     * 选择订单
     */
    selOrder: function selOrder(list) {
      var selID = [];
      list.map(function (item) {
        selID.push(item.order_id);
      });
      this.selID = selID;
    },
    /**
     * 发货
     */
    deliver: function deliver(row) {
      var _this7 = this;
      var order_id = row ? [row.order_id] : this.selID;
      if (order_id.length == 0) {
        this.$message({
          message: '请选择需要发货的订单',
          type: 'error'
        });
        return;
      }
      this.$prompt('请输入补宝备注', '设备发货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this7.loadObj = _this7.$loading({
              lock: true,
              text: '正在提交',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;
            _this7.$post('agentapi/business/delivery_bao', {
              order_id: order_id,
              agree: 1,
              delivery_sn: value
            }).then(function (res) {
              _this7.loadObj.close();
              _this7.$message({
                message: '发货成功',
                type: 'success'
              });
              _this7.toQuery();
            }).catch(function (err) {
              _this7.loadObj.close();
            });
          } else {
            done();
          }
        }
      });
    },
    /**
     * 缩水恢复
     */
    stealDel: function stealDel() {
      var _this8 = this;
      this.$prompt('请输入订单单号', '缩水恢复', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this8.loadObj = _this8.$loading({
              lock: true,
              text: '正在提交',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;
            _this8.$post('agentapi/business/show_hidding_order', {
              order_sn: value
            }).then(function (res) {
              // 【操作埋点】2026-05-25 pc_order_steal_1 缩水恢复（按单号）
              _this8.$orderReport.reportOrderSteal(value);
              _this8.loadObj.close();
              _this8.$message({
                message: '恢复成功',
                type: 'success'
              });
              done();
            }).catch(function (err) {
              _this8.loadObj.close();
            });
          } else {
            done();
          }
        }
      });
    },
    /**
    * 退夜间服务费
    */
    nightfeeRefund: function nightfeeRefund(row) {
      var _this9 = this;
      this.$alert('确定该订单夜间服务费退款吗？', '退夜间服务费', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this9.clickSubmit = true;
            _this9.$post('agentapi/order/nightfee_refund', {
              order_id: row.order_id
            }).then(function (res) {
              // 【操作埋点】2026-05-25 pc_order_refund_1 退夜间服务费
              _this9.$orderReport.reportOrderRefund(row.order_sn || row.order_id, row.night_fee || '', '退夜间服务费');
              _this9.$message({
                message: '退款成功',
                type: 'success'
              });
            }).catch(function (err) {
              _this9.$message({
                message: '退款失败',
                type: 'error'
              });
            });
          }
        }
      });
    },
    stealRestore: function stealRestore(row) {
      var _this0 = this;
      this.$alert('确定恢复该订单吗？', '恢复订单', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this0.clickSubmit = true;
            _this0.$post('agentapi/business/show_hidding_order', {
              order_sn: row.order_sn
            }).then(function (res) {
              // 【操作埋点】2026-05-25 pc_order_steal_1 恢复缩水订单
              _this0.$orderReport.reportOrderSteal(row.order_sn);
              _this0.$message({
                message: '恢复成功',
                type: 'success'
              });
              //刷新列表
              _this0.toQuery();
            }).catch(function (err) {
              _this0.$message({
                message: '恢复失败',
                type: 'error'
              });
            });
          }
        }
      });
    },
    cancelRestore: function cancelRestore(row) {
      var _this1 = this;
      this.$alert('确定恢复异常退款吗？', '恢复异常退款', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this1.clickSubmit = true;
            _this1.$post('agentapi/business/cancelOrderRefund', {
              order_sn: row.order_sn
            }).then(function (res) {
              _this1.$message({
                message: '恢复成功',
                type: 'success'
              });
            }).catch(function (err) {
              _this1.$message({
                message: '恢复失败',
                type: 'error'
              });
            });
          }
        }
      });
    },
    recoverDegree: function recoverDegree(row) {
      var _this10 = this;
      this.$alert('确定恢复度数吗？', '恢复度数', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this10.clickSubmit = true;
            _this10.$post('agentapi/search/recoverDegree', {
              order_id: row.order_id
            }).then(function (res) {
              _this10.$message({
                message: '恢复成功',
                type: 'success'
              });
              _this10.getList();
            }).catch(function (err) {
              _this10.$message({
                message: '恢复失败',
                type: 'error'
              });
            });
          }
        }
      });
    },
    /**
     * 处理退款点击事件
     * @param {Object} row 订单数据
     */
    handleRefundClick: function handleRefundClick(row) {
      var _this11 = this;
      if (row.steal_type != 0) {
        this.$confirm('该笔订单有漏单，是否先恢复漏单再退款？', '漏单提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(function () {
          _this11.stealRestore(row);
        }).catch(function () {
          _this11.refundDialog = true;
          _this11.order = row;
          _this11.refundObj.refund_money = '';
          _this11.refundObj.refund_2_balance = _this11.siteInfo.drawbacke_2_balance;
        });
      } else {
        this.refundDialog = true;
        this.order = row;
        this.refundObj.refund_money = '';
        this.refundObj.refund_2_balance = this.siteInfo.drawbacke_2_balance;
      }
    },
    /**
     * 订单退款
     */
    refundOrder: function refundOrder(row) {
      var _this12 = this;
      this.$alert('确认给该笔订单退款吗？', '订单退款', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this12.clickSubmit = true;
            _this12.$post('agentapi/business/drawback_paid_order', {
              order_id: row.order_id,
              refund_money: _this12.refundObj.refund_money,
              refund_2_balance: _this12.refundObj.refund_2_balance,
              refund_reason: _this12.refundObj.refund_reason
            }).then(function (res) {
              // 【操作埋点】2026-05-25 pc_order_refund_1 订单退款
              _this12.$orderReport.reportOrderRefund(row.order_sn || row.order_id, _this12.refundObj.refund_money, "\u9000\u81F3\u4F59\u989D\uFF1A".concat(_this12.refundObj.refund_2_balance == 1 ? '是' : '否', "\uFF0C\u539F\u56E0\uFF1A").concat(_this12.refundObj.refund_reason || '无'));
              _this12.refundDialog = false;
              _this12.clickSubmit = false;
              _this12.$message({
                message: '退款成功',
                type: 'success'
              });
              row.refund_drawbacked = _this12.refundObj.refund_money;
            }).catch(function (err) {
              _this12.clickSubmit = false;
            });
          }
        }
      });
    },
    /**
     * 查询订单详情
     */
    getOrderDetail: function getOrderDetail(row) {
      var _this13 = this;
      this.$get('wxapi/order_detail', {
        order_id: row.order_id
      }).then(function (res) {
        res.agents_profit = res.order_info.agents_profit;
        res.money_paid = res.order_info.money_paid;
        res.night_fee = res.order_info.night_fee;
        _this13.order = res;
        _this13.detailDialog = true;
      });
    },
    /**
     * 查询宝的最新信息
     */
    checkBao: function checkBao(bao_sn) {
      var _this14 = this;
      this.$get('commonapi/check/bao_status', {
        bao_sn: bao_sn
      }).then(function (res) {
        _this14.baoDialog = true;
        _this14.baoList = [res];
      });
    },
    /**
     * 退款详情
     */
    refundInfo: function refundInfo(row) {
      var _this15 = this;
      this.$get('wxapi/order/order_refund_appy_detail', {
        order_id: row.order_id
      }).then(function (res) {
        _this15.washRefundDialog = true;
        _this15.washRefund = res[0];
      });
    },
    /**
     * 审核提现
     * @param {Object} row
     */
    upApply: function upApply(row, agree) {
      var _this16 = this;
      if (agree == 1) {
        this.$alert('确定通过吗？', '通过退款申请', {
          confirmButtonText: '确定',
          callback: function callback(action) {
            if (action == 'confirm') {
              if (_this16.clickSubmit) return;
              _this16.clickSubmit = true;
              _this16.postApply(row, agree);
            }
          }
        });
      } else if (agree == 0) {
        this.$prompt('', '驳回退款申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: '',
          inputPlaceholder: '驳回原因'
        }).then(function (_ref) {
          var value = _ref.value;
          if (_this16.clickSubmit) return;
          _this16.clickSubmit = true;
          _this16.postApply(row, agree, value);
        });
      }
    },
    /**
     * 提交选择结果
     * @param {Object} id
     * @param {Object} agree
     */
    postApply: function postApply(row, agree, refund_reason) {
      var _this17 = this;
      this.$post('agentapi/order/audit_refund_appy', {
        order_id: row.order_id,
        agree: agree,
        refuse_reason: refund_reason
      }).then(function (res) {
        _this17.$message({
          message: '提交成功',
          type: 'success'
        });
        if (row.depend_type == 4) row.order_status = agree == 0 ? 1 : 3;
        row.refund_apply_status = agree == 0 ? 2 : 3;
        _this17.clickSubmit = false;
      }).catch(function (err) {
        _this17.clickSubmit = false;
      });
    },
    /**
     * 订单扣款
     */
    deduct: function deduct(row) {
      var _this18 = this;
      this.loadObj = this.$loading({
        lock: true,
        text: '',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/order/press_paying_fund_order', {
        order_id: row.order_id
      }).then(function (res) {
        _this18.loadObj.close();
        _this18.$message({
          message: res.msg,
          type: 'success'
        });
      }).catch(function (err) {
        _this18.loadObj.close();
      });
    },
    /**
     * setSort
     */
    deviceSort: function deviceSort() {
      var _this19 = this;
      this.$nextTick(function () {
        var el = _this19.$refs.dragDevice.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
        _this19.sortable = _sortablejs.default.create(el, {
          ghostClass: 'sortable-ghost',
          // Class name for the drop placeholder,
          setData: function setData(dataTransfer) {
            // to avoid Firefox bug
            // Detail see : https://github.com/RubaXa/Sortable/issues/1012
            dataTransfer.setData('Text', '');
          },
          onEnd: function onEnd(evt) {
            var targetRow = _this19.deviceSortArr.splice(evt.oldIndex, 1)[0];
            _this19.deviceSortArr.splice(evt.newIndex, 0, targetRow);
          }
        });
      });
    },
    /**
     * 设备类型排序提交
     */
    postDeviceSort: function postDeviceSort() {
      var _this20 = this;
      var params = {
        take_my_depend_sort: 1,
        depend_sort: {}
      };
      this.loadObj = this.$loading({
        lock: true,
        text: '',
        spinner: 'el-icon-loading'
      });
      this.deviceSortArr.map(function (item, index) {
        params.depend_sort[item.depend_type] = _this20.deviceSortArr.length - index;
      });
      this.$post('agentapi/ucenter/depend_sort', params).then(function (res) {
        _this20.$store.dispatch('user/getDeviceType').then(function (data) {
          _this20.deviceSortDialog = false;
          _this20.$message({
            message: res.msg,
            type: 'success'
          });
          _this20.loadObj.close();
        });
      });
    },
    /**
     * 提交操作记录
     * @param {Object} order_type
     */
    postSetRecode: function postSetRecode(order_type) {
      if (order_type == this.order_type) return;
      this.order_type = order_type;
      switch (parseInt(order_type)) {
        case 4:
          // 全部
          this.tag_type = 1;
          break;
        case 0:
          // 今日订单
          this.tag_type = 3;
          break;
        case 1:
          // 使用中
          this.tag_type = 2;
          break;
        case 2:
          // 已完成
          this.tag_type = 4;
          break;
        case 3:
          // 超时借出
          this.tag_type = 5;
          break;
        case 5:
          // 租借失败
          this.tag_type = 6;
          break;
        case 6:
          // 0元订单
          this.tag_type = 1;
          break;
        case 7:
          // 扣款失败
          this.tag_type = 7;
          break;
        case 8:
          // 申请退款
          this.tag_type = 8;
          break;
      }
      if (!this.tag_type) return;
      this.$store.dispatch('user/postSetRecode', [2, parseInt(this.user_type) + 1, this.tag_type]);
    },
    /**
     * 导出
     */
    outTable: function outTable() {
      this.outStatus = true;
      this.listLoading = true;
      this.listQuery.limit = 1000;
      this.list = [];
      this.excel = true;
      this.getList();
    },
    /**
     * 导出表格
     */
    outTabdd: function outTabdd(tabId) {
      var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data';
      var fix = document.querySelector('.el-table__fixed-right');
      var xlsxParam = {
        raw: true
      };
      var wb;
      if (fix) {
        this.wbout[this.wi] = _xlsx.default.utils.table_to_book(document.querySelector("#".concat(tabId)).removeChild(fix), xlsxParam);
        document.querySelector("#".concat(tabId)).appendChild(fix);
      } else {
        this.wbout[this.wi] = _xlsx.default.utils.table_to_book(document.querySelector("#".concat(tabId)), xlsxParam);
      }
      this.wi++;
      if (this.listLoading) {
        this.getList();
        return;
      }
      var wboutes = this.wbout[0];
      var no = '';
      for (var i in this.wbout) {
        delete this.wbout[i].Sheets.Sheet1['!merges'];
        if (i > 0) {
          var sheet1 = this.wbout[i].Sheets.Sheet1;
          for (var s in sheet1) {
            var k = s.substring(0, 1);
            var n = s.substring(1);
            if (n != 1 && n != 'ref') {
              var _k = s.substring(0, 1);
              n = s.substring(1);
              no = parseInt(i) * this.listQuery.limit + parseInt(n);
              sheet1[_k + no] = sheet1[s];
            }
            delete sheet1[s];
          }
          wboutes.Sheets.Sheet1 = Object.assign(wboutes.Sheets.Sheet1, sheet1);
        }
      }
      if (this.wbout[1]) wboutes.Sheets.Sheet1['!ref'] = "A1:Q".concat(no);
      var wbout = _xlsx.default.write(wboutes, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });
      this.percentage = 100;
      if (!this.listLoading) {
        try {
          _fileSaver.default.saveAs(new Blob([wbout], {
            type: 'application/octet-stream'
          }), "".concat(fileName, ".xlsx"));
          this.excel = false;
          this.$message({
            message: '导出成功',
            type: 'success'
          });
          setTimeout(function () {
            location.reload();
          }, 1000);
        } catch (e) {
          if (typeof console !== 'undefined') console.log(e, this.wbout);
        }
        return this.wbout;
      }
    },
    /**
     * 显示订单交易统计弹窗
     */
    showOrderStatsDialog: function showOrderStatsDialog() {
      var _this21 = this;
      this.orderStatsDialogVisible = true;
      this.$nextTick(function () {
        // 弹窗打开后初始化图表数据
        _this21.switchPeriod(_this21.currentPeriod);
      });
    },
    /**
     * 关闭订单交易统计弹窗
     * @param done
     */
    handleOrderStatsClose: function handleOrderStatsClose(done) {
      this.$confirm('确认关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    /**
     * 订单交易统计-柱状图
     * @param period (days：今天，yesterday：昨日，week：本周，lastWeek：上周，month：本月，lastMonth：上月，quarter：季度，year：年度，total：合计）
     */
    switchPeriod: function switchPeriod(period) {
      var _this22 = this;
      this.currentPeriod = period;
      // 清空自定义时间范围
      this.customPeriodRange = [];
      // 设置显示的时间范围文本
      this.currentPeriodText = this.getPeriodText(period);
      // 显示加载提示
      this.chartLoading = true;
      // 调用后端接口获取数据
      this.getDeviceChartData(period).then(function () {
        // 数据加载完成后关闭加载提示
        _this22.chartLoading = false;
      }).catch(function () {
        // 出错时也关闭加载提示
        _this22.chartLoading = false;
      });
    },
    /**
     * 处理自定义时间范围选择
     */
    switchCustomPeriod: function switchCustomPeriod() {
      var _this23 = this;
      if (this.customPeriodRange && this.customPeriodRange.length === 2) {
        var _this$customPeriodRan = (0, _slicedToArray2.default)(this.customPeriodRange, 2),
          startDate = _this$customPeriodRan[0],
          endDate = _this$customPeriodRan[1];
        // 构建时间范围字符串，格式为 '开始时间|结束时间'
        var period = "".concat(startDate, "|").concat(endDate);
        this.currentPeriod = 'custom'; // 设置为自定义模式
        // 更新时间范围显示文本
        this.currentPeriodText = "".concat(startDate, " \u81F3 ").concat(endDate);
        // 显示加载提示
        this.chartLoading = true;
        // 调用后端接口获取数据
        this.getDeviceChartData(period).then(function () {
          // 数据加载完成后关闭加载提示
          _this23.chartLoading = false;
        }).catch(function () {
          // 出错时也关闭加载提示
          _this23.chartLoading = false;
        });
      } else {
        // 如果清空了自定义时间范围，可以默认回到今天
        this.switchPeriod('days');
      }
    },
    /**
     * 获取时间范围文本
     * @param period 时间段标识
     */
    getPeriodText: function getPeriodText(period) {
      var periodLabels = {
        'days': '今天',
        'yesterday': '昨天',
        'week': '本周',
        'lastWeek': '上周',
        'month': '本月',
        'lastMonth': '上月',
        'quarter': '近3月',
        'year': '当年',
        'total': '合计'
      };
      return periodLabels[period] || '自定义时间';
    },
    /**
     * 获取设备类型统计数据
     * @param period (days：今天，yesterday：昨日，week：本周，lastWeek：上周，month：本月（默认转值），lastMonth：上月，quarter：季度，year：年度，total：合计)
     */
    getDeviceChartData: function getDeviceChartData() {
      var _this24 = this;
      var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'days';
      // 调用后端接口获取数据
      return this.$get('agentapi/data_overview/overview_order_transaction', {
        period: period
      }).then(function (res) {
        if (res != null) {
          _this24.summary = {
            orderAmount: res.orderAmount,
            fee: res.fee,
            total: res.total,
            feeTariff: res.feeTariff || '' //手续费的费率
          };
          //  如果 res.chartData 中的name 存在 \\n 则自动转义为换行的
          res.chartData.forEach(function (item) {
            item.name = item.name.replace(/\\n/g, '\n');
          });
          _this24.deviceChartData = res.chartData;
          _this24.initDeviceChart();
        } else {
          _this24.$message.error('暂无数据信息。');
        }
      }).catch(function (err) {
        // 弹窗提示
        _this24.$message.error('获取总览数据失败，请稍后重试');
      });
    },
    /***
     * 订单交易类型 | 设备类型统计-柱状图
     */
    initDeviceChart: function initDeviceChart() {
      var chart = _echarts.default.init(document.getElementById('deviceChart'), 'macarons');
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          // 增加底部边距，为横坐标标签提供更多空间
          bottom: 80,
          left: 60,
          right: 60,
          top: 40,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.deviceChartData.map(function (item) {
            return item.name;
          }),
          axisLabel: {
            // 设置标签旋转角度，避免重叠
            rotate: 0,
            // 保证标签不被隐藏
            interval: 0,
            // 设置标签样式
            margin: 15,
            textStyle: {
              fontSize: 12
            }
          },
          // 防止标签溢出
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '金额（元）'
        },
        series: [{
          name: '交易金额',
          type: 'bar',
          data: this.deviceChartData.map(function (item) {
            return item.value;
          }),
          itemStyle: {
            color: '#3888fa'
          },
          // 设置柱条宽度，避免过宽导致显示问题
          barWidth: '60%',
          // 在每个柱状图上方显示金额
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return '¥' + params.value;
            },
            textStyle: {
              color: '#666'
            }
          }
        }]
      });
    }
  }
};